export const quizQuestions2 = [
  {
    id: "question4",
    videoId: "video4",
    topic: "Braking",
    question:
      "A vehicle running at 100kph should have at least a Total Stopping Distance of:",
    options: ["30 meters", "50 meters", "80 meters"],
    correctAnswer: "80 meters",
    descriptionTitle: "Braking",
    description1:
      "Always avoid tailgaiting. Tailgaiting is when you follow or stay close to another vehicle’s rear end. When this happens, you will have less room to maneuver and control your vehicle when you will be needing to switch lanes or brake.",
    description2:
      " The proper breaking distance should always be observed in order to avoid collision with other vehicles. For example, a vehicle running a speed of 100kph will need a 60 meters braking distance in order to fully stop. The driver needs to allow at least this distance.",
    description3:
      " Always allowing extra distance from another vehicle allows our brain to have a split second time to react and respond. The best practice is to allow a perception distance of 20 meters if a vehicle is running at 100kph.",
    description4:
      " Total stopping distance means that we will combine the proper braking distance and the perception/reaction distance in order to calculate the total stopping distance. For a vehicle running 100kph, 60 meters plus 20 meters will be a total distance of 80 meters. This distance should be observed in this specific scenario only.",
  },
];
